<template>
  <div class="lottery-list">
    <game-gearing ref="gameGearing"></game-gearing>
    <lida-table
      :propscolumns="column"
      :data="filterData"
      :sortStatus="false"
      :LeaveSpace="!sortSate"
      :propsPageSize="50"
      propsRowKey="id"
    >
      <template v-slot:headerSelect>
        <Button
          class="mr-2"
          type="primary"
          @click="modalAddSiteGame = !modalAddSiteGame"
        >新增站点游戏</Button>
        <Button
          type="warning"
          v-show="!sortSate"
          @click="sortSate = !sortSate"
        >游戏开关</Button>
        <span v-show="sortSate">
          <Button
            type="error"
            @click="updatelist"
            :loading="sortSateLoading"
          >储存</Button>
        </span>
        <span
          v-for="it in filterConditionArr"
          :key="it.id"
          style="width: 130px"
        >
          <span class="mx-2">{{ it.text }}</span>
          <Select v-model="filterCondition[it.id]">
            <Option
              v-for="(item, idx) in it.arr"
              :value="item.val"
              :key="idx"
            >{{ item.text }}</Option>
          </Select>
        </span>
      </template>
    </lida-table>
    <ModalAddSiteGame
      :state.sync="modalAddSiteGame"
      :memgamelist="items"
      @repull="getdata"
    />
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import idopColor from '@/mixins/idopColor'
import triggerColumns from "@/mixins/triggerColumns"
import { markSates } from '@/plugins/utils/game-id-filter.js';
import filterConditions from '@/mixins/filter-conditions.js'
import ModalAddSiteGame from '@/views/acount/components/ModalAddSiteGame'
import GameGroupMethods from 'utils/game-group-methods.js'
const gameGroupMethods = new GameGroupMethods()
export default {
  name: 'LotteryList',
  mixins: [idopColor, triggerColumns, filterConditions],
  components: {
    'GameGearing': () => import(/* webpackChunkName: "GameGearing" */ './GameGearing.vue'),
    ModalAddSiteGame
  },
  data () {
    return {
      items: [],
      modalAddSiteGame: false,
      sortSate: false,
      sortSateLoading: false,
      mid: null,
      filterCondition: {
        isLow: 999,
        ismy: 999,
        group: 999,
        idop: 999
      },
      column: {
        id: {
          title: '排序',
          key: 'id',
          align: 'center',
          sortable: true,
          className: "infor-column",
        },
        isLow: {
          title: '高低频',
          key: 'isLow',
          align: 'center',
          sortable: true,
          className: "infor-column",
          render: (h, params) => {
            return h('p', `${params.row.isLow == 1 ? '低' : '高'}频彩`)
          },
        },
        ismy: {
          title: '彩种类型',
          key: 'ismy',
          align: 'center',
          sortable: true,
          className: "infor-column",
          render: (h, parmas) => {
            return h('p', parmas.row.ismy == 1 ? '自开彩' : '官彩')
          },
        },
        groupName: {
          title: '彩种系列',
          key: 'groupName',
          align: 'center',
          sortable: true,
          className: "infor-column",
        },
        gamename: {
          title: '彩种名称',
          key: 'gamename',
          align: 'center',
          sortable: true,
        },
        idop: {
          title: '游戏',
          key: 'idop',
          align: 'center',
          sortable: true,
          renderHeader: (this.triggerHeaderIdop),
          render: (h, params) => this.triggerIdop(h, params, 'id', 'idop')
        },
        isAudit: {
          title: '游戏查帳',
          key: 'isAudit',
          align: 'center',
          sortable: true,
          width: '250px',
          renderHeader: (this.triggerHeaderIdop),
          render: (h, params) => this.triggerIdop(h, params, 'id', 'isAudit')
        },
        indexNumber: {
          title: '玩法开关',
          key: 'idop',
          align: 'center',
          width: '100px',
          render: (h, params) => {
            if (!this.checkMarkSixLow(params.row.id)) return
            const gameGearingClick = {
              click: () => this.$refs.gameGearing.getlist(params.row.id, this.$route.query.siteid)
            }
            return h('a', {
              props: {
                type: 'warning',
                disabled: this.sortSateLoading || this.sortSate
              },
              on: gameGearingClick
            }, '設定')
          }
        },
      }
    }
  },
  computed: {
    ...mapGetters(['getmember', 'getgameid', 'getAllGame']),
    filterConditionArr () {
      let result = [
        { id: 'isLow', val: this.filterCondition.isLow, text: '高低频', arr: this.isLowArr },
        { id: 'ismy', val: this.filterCondition.ismy, text: '彩种类型', arr: this.ismyArr },
        { id: 'group', val: this.filterCondition.group, text: '彩种系列', arr: this.catenaIdArr },
        { id: 'idop', val: this.filterCondition.idop, text: '启用状态', arr: this.idopArr },
      ]
      return result
    },
    filterData () {
      let filterData = []
      let obj = {
        isLow: this.filterCondition.isLow == 999 ? undefined : this.filterCondition.isLow,
        ismy: this.filterCondition.ismy == 999 ? undefined : this.filterCondition.ismy,
        group: this.filterCondition.group == 999 ? undefined : this.filterCondition.group,
        idop: this.filterCondition.idop == 999 ? undefined : this.filterCondition.idop,
      }
      for (let key in obj) { //先删除不需要的条件
        if (obj[key] == undefined) delete obj[key]
      }
      const conditionArr = Object.keys(obj)
      if (conditionArr.length == 0) return this.items
      const fn = (arr, cit) => {
        let result = arr.filter(it => it[cit] == obj[cit])
        return result
      }
      conditionArr.forEach((cit, cidx) => {
        if (cidx == 0) {
          filterData = fn(this.items, cit)
        } else {
          filterData = fn(filterData, cit)
        }
      })
      return filterData
    }
  },
  created () {
    this.getdata()
  },
  methods: {
    async getdata () {

      try {
        const res = await this.$axios.acount.memgamelist(this.$route.query.siteid)
        if ('status' in res && res.status === 0) return
        if ('data' in res === false) return
        this.items = res.data.map(it => {
          let find = this.getAllGame.find(item => item.gameid == it.id)
          it.idop = Number(it.upidop)
          it.isAudit = Number(it.isAudit)
          it.idopText = it.upidop ? '开启' : '关闭'
          it.auditText = it.isAudit ? '开启' : '关闭'
          it.defaultidop = it.upidop
          it.defaultaudit = it.isAudit
          it.isLow = markSates.onlySix(it.id) ? 1 : 2
          it.catenaId = find ? find.catenaId : 11
          it.groupName = gameGroupMethods.catenaGroup(it.catenaId)
          it.group = it.catenaId
          return it
        })
      } catch (error) {
        console.error(error)
      }
    },
    async updatelist () {
      const gameitme = this.modifyArray(this.items, (it) => ({ gameid: it.id, idop: it.idop }))
      const audittme = this.items.filter(it => it.defaultaudit != it.isAudit).map(it => ({ gameid: it.id, audit: it.isAudit }))
      if (!gameitme.length && !audittme.length) return this.sortSate = false;
      this.sortSateLoading = true
      try {
        const data = {
          mid: this.$route.query.siteid,
          loid: this.getmember.pid,
          gameitme: gameitme,
          audittme: audittme
        }
        const res = await this.$axios.acount.memgamelist_update(data)
        if (res.status === 1) {
          this.$Message.success('已修改');
          this.getdata()
          this.sortSate = false;
        }
        this.sortSateLoading = false
      } catch (err) {
        this.$Message.error('網路異常');
        this.sortSateLoading = false
      }
    },
    checkMarkSixLow (gameid) { // 判斷是否為 低頻彩六合彩遊戲
      if (!gameid) return
      const array = this.getAllGame.filter(it => it.gameGroupId === 1)
      const result = array.some(it => it.gameid == gameid)
      return [1, 14, 15, 78, 210, 212, 201, 224, 225, 226, 227, 228].includes(gameid)
    }
  }
}
</script>
<style lang="scss">
.lottery-list {
  span {
    .ivu-select {
      width: auto;
    }
  }
}
</style>